// extracted by mini-css-extract-plugin
module.exports = {"image":"te-z","loaded":"ue-z","placeholder":"ve-z"};